module.exports = __webpack_public_path__ + "media/images/pear_1-6b526b3c58e7bcd10e4e245a515a5736.jpg";